import React from "react";
import { Modal } from "../../../../../globalComponents/ui/Modal";
import styled from "styled-components";

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
`;

const Title = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: var(--ink);
  font-family: var(--font-sans);
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: var(--ink-4);
  line-height: 1;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ItemBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  background: #f8faff;
  border: 1.5px solid #e0e7ff;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  font-family: var(--font-sans);

  &:hover {
    background: #eff6ff;
    border-color: #bfdbfe;
  }
`;

const ItemIndex = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #93c5fd;
  font-family: var(--font-mono);
  min-width: 22px;
`;

const ItemName = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #2563eb;
  flex: 1;
`;

const ItemValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  border-radius: 20px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  font-size: 11px;
  font-weight: 700;
  color: #2563eb;
  font-family: var(--font-mono);
  white-space: nowrap;
  flex-shrink: 0;
`;

const Arrow = styled.span`
  font-size: 11px;
  color: var(--ink-4);
`;

/**
 * Modal overlay listing a KPI's sub-questions with click-to-navigate.
 */
const SubQuestionsModal = ({ subQuestions = [], onClose, onNavigate }) => (
  <Modal show={subQuestions.length > 0} onClose={onClose} maxWidth={460}>
    <div style={{ padding: "24px 24px 20px" }}>
      <Header>
        <Title>Sub Questions</Title>
        <CloseBtn onClick={onClose}>✕</CloseBtn>
      </Header>
      <List>
        {subQuestions.map((sub, i) => (
          <ItemBtn key={sub.id} onClick={() => onNavigate(sub.id)}>
            <ItemIndex>{i + 1}.</ItemIndex>
            <ItemName>{sub.kpi_name}</ItemName>
            {sub.value != null && (
              <ItemValue>
                {sub.value}
                {sub.unit && sub.unit !== "-" ? ` ${sub.unit}` : ""}
              </ItemValue>
            )}
            <Arrow>↗</Arrow>
          </ItemBtn>
        ))}
      </List>
    </div>
  </Modal>
);

export default SubQuestionsModal;
